<template>
  <div class="app-page">
    <ApplyHeader :offline="offline" />
    <div class="application-page-container" v-if="applicationRecord.length > 0">
      <a-table
        class="job-table"
        :rowKey="(record) => record.id"
        :columns="columns"
        :data-source="applicationRecord"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>

        <template v-slot:headerCell="{ title, column }">
            {{ $t('user.' + title) }}
        </template>

        <template v-slot:bodyCell="{ record, column }">
          <template v-if="column.key === 'result'">
            <ApplyStatusColumn :data="record" />
          </template>
          <template v-else-if="column.key === 'details'">
            <router-link
              v-if="record.status != 0"
              :to="{ path: `/me/application/detail/${record.id}` }"
            >
              <a-button type="link">{{ $t('user.View') }}</a-button>
            </router-link>
          </template>
        </template>
      </a-table>
    </div>
    <div class="application-no-data" v-else>
      <div class="no-data-content">
        <img src="@/assets/no-data.png" />
        <div class="text">{{ $t("user.You don't have application yet") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAgencyOptions, getRoleOptions, getLevelOptions } from '@/api/dict'
import ApplyHeader from './components/ApplyHeader.vue'
import { getApplicationRecord } from '@/api/index'
import { QuestionCircleFilled } from '@ant-design/icons-vue'
import { ApplyStatusColumn } from '@/components/ApplyStatus/index.js'
import Empty from '@/components/Empty'
import { mapGetters } from 'vuex'

export default {
  name: 'Index',
  components: {
    ApplyHeader,
    ApplyStatusColumn,
    Empty,
  },
  data() {
    return {
      columns: [
        {
          title: 'Application Date',
          key: 'time',
          dataIndex: 'time',
        },
        {
          title: 'Current Role',
          key: 'current',
          dataIndex: 'current',
        },
        {
          title: 'Target Role',
          key: 'target',
          dataIndex: 'target',
        },
        {
          title: 'Panel Result',
          key: 'result',
          dataIndex: 'result',
        },
        {
          title: 'Details',
          key: 'details',
          dataIndex: 'details',
        },
      ],
      applicationRecord: [],
    }
  },
  computed: {
    ...mapGetters({
      offlineMode: 'user/offlineMode',
    }),
    offline() {
      return this.offlineMode
    },
  },
  mounted() {
    getApplicationRecord().then((res) => {
      if (res.code == 200) {
        this.applicationRecord = res.data
      }
    })
  },
  methods: {
    getIndicatorStatusClass(data) {
      if (data.result === 'Pending') {
        return 'pending'
      } else if (data.result === 'Approve for Panel') {
        return 'success'
      } else if (data.result === 'Disapprove for Panel') {
        return 'error'
      } else {
        return null
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import url('@/styles/params.less');

.application-page-container {
  margin: @app-conetent-margin;
}

.application-no-data {
  margin: @app-conetent-margin;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 140px 0;

  .no-data-content {
    width: 220px;
    text-align: center;

    img {
      width: 106px;
    }

    .text {
      margin: 40px auto;
      font-size: 16px;
    }
  }
}
</style>
